import { useQueryClient } from '@tanstack/react-query';
import collectionApiClient, { DraftCollection } from '../../../api/collections';
import useKlydoMutation from '../../../hooks/useKlydoMutation';

/**
 * Runs on the shared useKlydoMutation wrapper — the base every mutation is
 * supposed to use. Before this it sat on a bare useMutation with no error
 * handling at all, so a failed collection save died in silence; now the api's
 * message surfaces through the standard alert, and a 409 — the collection
 * changed under this view, e.g. it stopped being an editable draft while the
 * screen was open — resyncs every query the way the klydo mutations do.
 */
const useUpsertCollectionMutation = () => {
  const queryClient = useQueryClient();
  return useKlydoMutation({
    mutationKey: ['upsert-collection'],
    mutationFn: ({
      collectionId,
      collection,
    }: {
      collectionId: string;
      collection: Partial<DraftCollection>;
    }) => {
      return collectionApiClient.upsertCollection(collectionId, collection);
    },
    onSuccess: (data, variables) => {
      queryClient.invalidateQueries({
        queryKey: ['collection', variables.collectionId],
      });
    },
  });
};

export default useUpsertCollectionMutation;
